(function () {
  const bar = document.getElementById("StickyATC");
  if (!bar) return;

  const btn = document.getElementById("StickyATCBtn");
  const btnText = document.querySelector("#StickyATCBtn .sticky-atc__btnText");

  const elTitle = document.getElementById("StickyATCTitle");
  const elPrice = document.getElementById("StickyATCPrice");
  const elCompare = document.getElementById("StickyATCCompare");
  const elImg = document.getElementById("StickyATCImg");

  // --- Impulse product form selectors (covers most versions) ---
  const productForm =
    document.querySelector('form[data-product-form]') ||
    document.querySelector('form.product-single__form') ||
    document.querySelector('form[action^="/cart/add"]');

  // Show/hide trigger: product wrapper (fallback to form)
  const showAfterEl =
    document.querySelector('.product-section') ||
    document.querySelector('.product-single') ||
    productForm;

  const product = window.__STICKY_ATC_PRODUCT__ || null;

  function formatMoney(cents) {
    const format =
      (window.Shopify && Shopify.money_format) ? Shopify.money_format : "${{amount}}";
    const value = (cents / 100).toFixed(2);
    return format.replace("{{amount}}", value);
  }

  function getSelectedVariantId() {
    if (!productForm) return null;

    // Most themes keep current variant in input[name="id"]
    const idInput = productForm.querySelector('input[name="id"], select[name="id"]');
    return idInput ? idInput.value : null;
  }

  function findVariant(variantId) {
    if (!product || !product.variants) return null;
    return product.variants.find(v => String(v.id) === String(variantId)) || null;
  }

  function setButtonState(available) {
    if (!btn) return;
    btn.disabled = !available;

    // IMPORTANT: update the <span> text so we don't destroy the inner HTML
    if (btnText) {
      btnText.textContent = available ? "ADD TO CART" : "SOLD OUT";
    }
  }

  function updateBar() {
    const variantId = getSelectedVariantId();
    const variant = variantId ? findVariant(variantId) : null;

    // Title stays as product title like your screenshot
    if (product && elTitle) elTitle.textContent = product.title;

    if (!variant) return;

    // Price
    if (elPrice) elPrice.textContent = formatMoney(variant.price);

    // Compare-at price (show/hide)
    if (elCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        elCompare.textContent = formatMoney(variant.compare_at_price);
        elCompare.style.display = "";
      } else {
        elCompare.textContent = "";
        elCompare.style.display = "none";
      }
    }

    // Image: variant image if available, otherwise product image
    const imgSrc =
      (variant.featured_image && variant.featured_image.src) ||
      (product.featured_image && product.featured_image.src) ||
      null;

    if (elImg && imgSrc) {
      elImg.src = imgSrc;
    }

    // Availability
    setButtonState(!!variant.available);
  }

  function setVisibility() {
    if (!showAfterEl) return;

    const rect = showAfterEl.getBoundingClientRect();

    // Show once the main product area is off-screen
    // If you want it to appear sooner/later, change 0 to 120, etc.
    const shouldShow = rect.bottom < 0;

    bar.classList.toggle("is-visible", shouldShow);
    bar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
  }

  function clickRealAddToCart() {
    if (!productForm) return;

    // Prefer clicking the real submit button (keeps all theme/cart-drawer logic)
    const realBtn =
      productForm.querySelector('button[type="submit"][name="add"]') ||
      productForm.querySelector('button[type="submit"]') ||
      productForm.querySelector('input[type="submit"]');

    if (realBtn) realBtn.click();
    else productForm.submit();
  }

  function hookButton() {
    if (!btn) return;

    btn.addEventListener("click", () => {
      // If sold out, do nothing
      if (btn.disabled) return;
      clickRealAddToCart();
    });
  }

  function watchVariantChanges() {
    // 1) Change event (Impulse updates variant input)
    document.addEventListener("change", (e) => {
      // Update when anything changes inside the product form
      if (productForm && e.target && productForm.contains(e.target)) {
        updateBar();
      }
    });

    // 2) Polling fallback (safe for any custom variant UI)
    let lastId = null;
    setInterval(() => {
      const id = getSelectedVariantId();
      if (id && id !== lastId) {
        lastId = id;
        updateBar();
      }
    }, 300);

    // 3) Some themes dispatch this
    document.addEventListener("variant:change", updateBar);
  }

  // --- Init ---
  updateBar();
  setButtonState(true);
  setVisibility();
  hookButton();
  watchVariantChanges();

  window.addEventListener("scroll", setVisibility, { passive: true });
  window.addEventListener("resize", setVisibility);
})();
